import React from 'react';
import Headers from './components/Header';
import About from './components/About';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Headers />
      <main>
        <section id="home" className="hero">
          <h2>Welcome to Jon David</h2>
          <p>Your partner for digital transformation.</p>
        </section>
        <About />
      </main>
      <Footer />
    </div>
  );
}

export default App;
